import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import videojs from 'video.js';
@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class VideoComponent implements OnInit, AfterViewInit {
  player: videojs.Player;

  @Input() src: string;
  @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef;

  ngOnInit(): void {
   
  }

  ngAfterViewInit(): void {
    this.player = videojs(this.videoPlayer.nativeElement, {
      autoplay: false,
      preload: 'auto',
      controls: false,
      bigPlayButton: false,
      controlBar: {
        playToggle: false,
        currentTimeDisplay: false,
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,
        liveDisplay: false,
        progressControl: true,
        volumePanel: false,
        fullscreenToggle: true,
      },
      sources: [
        {
          src: this.src,
          type: 'video/mp4',
        },
      ],
    });
    this.player.textTracks();
    this.player.on('click', (e) => {
      this.handleVideo(e);
    });
  }
  handleVideo(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    document.querySelectorAll('video').forEach((videoElem) => {
      const player = videojs(videoElem);
      if (player != this.player) {
        player.pause();
      }
    });
    this.toggleVideo(this.player.paused());
  }

  public changeSound(event: MouseEvent): void {
    event.stopPropagation();
    this.player.muted() ? this.player.muted(false) : this.player.muted(true);
  }

  toggleVideo(value: boolean) {
    console.log(value)
    if (value) {
      this.player.play();
    } else {
      this.player.pause();
    }
  }
}
